import { Text, Button } from '@chakra-ui/react';
import { type FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { type MaterialType } from '$/services/usecases/materials/mapper/materials';
import {
  useMaterialContextMenuStore,
  type MenuLayer,
} from '$/stores/useMaterialContextMenuStore';

interface Props {
  materialLabel: string;
  materialId: string;
  materialType?: MaterialType;
  menuLayer?: MenuLayer;
}

export const SavedFavoriteToastContent: FC<Props> = ({
  materialLabel,
  materialId,
  materialType,
  menuLayer,
}) => {
  const { t } = useTranslation();
  const setActiveMaterialContextMenuId =
    useMaterialContextMenuStore.useSetActiveMaterial();

  return (
    <>
      <Text fontSize='sm' wordBreak='break-word'>
        <Trans
          i18nKey='favorites.favoriteSavedToastDescription'
          values={{ materialName: materialLabel }}
          shouldUnescape
        />
      </Text>
      <Button
        p='0'
        color='primaryButton.background'
        fontSize='sm'
        fontWeight='bold'
        onClick={() =>
          setActiveMaterialContextMenuId(materialId, materialType, menuLayer)
        }
        variant='text'
      >
        {t('favorites.changeFolder')}
      </Button>
    </>
  );
};
